import React from "react";
import {observer} from "mobx-react-lite";
import {useTranslation} from "react-i18next";
import {useStores} from "../../../stores/useStores";
import Tag, {TagType} from "../tag/tag";

export interface IAreaTagProps {
  /**
   * The resident's person type id, as returned by the API.
   */
  personTypeId?: string;
}

/**
 * Shows which area a resident belongs to - independent apartment (IA) or
 * serviced apartment (SA).
 */
const AreaTag: React.FC<IAreaTagProps> = ({personTypeId}) => {
  const {t} = useTranslation(["translation"]);
  const {
    domainStore: {personTypesDomainStore}
  } = useStores();

  if (!personTypeId) {
    return null;
  }

  let type: TagType;
  let text: string;

  if (personTypeId === personTypesDomainStore.servicedPersonTypeId) {
    type = "system";
    text = t("translation:labels.area.servicedApartment");
  } else if (personTypeId === personTypesDomainStore.independentPersonTypeId) {
    type = "digital";
    text = t("translation:labels.area.independentApartment");
  } else {
    // Residents are only onboarded from the IA and SA departments, so any other
    // person type is unexpected and rendered blank rather than guessed at.
    return null;
  }

  return <Tag type={type} text={text} />;
};

export default observer(AreaTag);
